import React from 'react';
import { formatOre, VatLine } from '../../services/vat';

/**
 * "Varav moms 12 %" under totalen i butiken. Priserna är inklusive moms;
 * raderna visar hur mycket av summan som är moms, per sats.
 */
export const VatLines: React.FC<{ lines: VatLine[] | undefined; className?: string }> = ({ lines, className = '' }) => {
    const shown = (lines || []).filter(l => l.gross !== 0);
    if (shown.length === 0) return null;
    return (
        <div className={`space-y-0.5 ${className}`}>
            {shown.map(l => (
                <div key={l.rate} className="flex justify-between gap-3 text-[11px] text-stone-400 tabular-nums">
                    <span>Varav moms {l.rate} %{shown.length > 1 ? ` (på ${formatOre(l.gross)} kr)` : ''}</span>
                    <span>{formatOre(l.vat)} kr</span>
                </div>
            ))}
        </div>
    );
};
